module.exports = __webpack_public_path__ + "img/PL08770.6a166498.png";